import React from 'react';
import Helmet from 'helmet/helmet';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Route } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import { Site } from 'four-nets/site';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';
import TitleView from 'four-nets/ui/title-view';
import { CategoryStore } from 'four-nets/forum/forum';
import newArticle from 'four-nets/icons/svg/icon_new-article.svg';
import BigButtonView from 'four-nets/ui/big-button/big-button-view';
import NewThreadView, { NewThreadViewModel } from 'four-nets/forum/thread/new-thread/new-thread-view';
import { HideForVendor } from 'four-nets/vendor/permissions';
import ThreadsTableView from 'four-nets/forum/threads-table/threads-table-view';

import titleViewStyles from '../title-view-styles.scss';
import defaultStyles from './latest-topics-view.scss';

@Styled(defaultStyles)
@observer
class LatestTopicsView extends React.Component {
    static contextTypes = {
        origin: PropTypes.string,
        site: PropTypes.instanceOf(Site),
        categoryStore: PropTypes.instanceOf(CategoryStore),
        authCheck: PropTypes.func,
    };

    constructor(props, context) {
        super(props);

        const { categoryStore, site } = context;
        categoryStore.site = site;

        this.newThreadViewModel = new NewThreadViewModel({
            categoryStore,
            userStore: categoryStore.userStore,
        });
    }

    renderHelmet = H => {
        const { site } = this.context;

        return (
            <Route>
                {({ location }) => (
                    <FormattedMessage id='FORUM_LINK_LABEL'>
                        {linkLabel => (
                            <FormattedMessage id='FORUM_LATEST_TOPICS_TITLE'>
                                {mostActiveTopicsTitle => {
                                    const title = `${linkLabel} - ${mostActiveTopicsTitle} | ${site.name}`;

                                    return (
                                        <H>
                                            <title>{title}</title>,
                                            <meta property='og:title' content={title} />,
                                            <meta
                                                property='og:url'
                                                content={`${this.context.origin}${location.pathname}`}
                                            />
                                            ,
                                        </H>
                                    );
                                }}
                            </FormattedMessage>
                        )}
                    </FormattedMessage>
                )}
            </Route>
        );
    };

    newThreadViewModel: NewThreadViewModel;
    newThreadView: NewThreadView | undefined;

    setNewThreadView = (ref: ?NewThreadView) => {
        this.newThreadView = ref;
    };

    onNewThreadClick = () => {
        const { newThreadView } = this;

        if (newThreadView) {
            const action = () => {
                newThreadView.show({
                    form: this.newThreadViewModel.setupForm(),
                });
                return Promise.resolve();
            };

            this.context.authCheck(action, AuthOrigin.NewThread);
        }
    };

    render() {
        const { styles, loading, threadsTableViewModel } = this.props;
        const { newThreadViewModel } = this;

        return (
            <div>
                <Helmet render={this.renderHelmet} />
                <TitleView
                    style={{ components: titleViewStyles.titleViewComponents }}
                    title={
                        <h1 className={styles.heading}>
                            <FormattedMessage id='FORUM_LATEST_TOPICS_TITLE' />
                        </h1>
                    }
                    leftComponent={
                        <HideForVendor>
                            <BigButtonView
                                icon={newArticle}
                                label={<FormattedMessage id='NEW_THREAD_BUTTON' />}
                                onClick={this.onNewThreadClick}
                            />
                        </HideForVendor>
                    }
                />
                <ThreadsTableView loading={loading} sortable={false} threadsTableViewModel={threadsTableViewModel} />
                <NewThreadView innerRef={this.setNewThreadView} newThreadViewModel={newThreadViewModel} />
            </div>
        );
    }
}

export default LatestTopicsView;
